export default __webpack_public_path__ + "static/media/offline.0f234151.svg";